// src/TermsOfService.js
import React from "react";
import logo from "./logo.svg";

const TermsOfService = ({ appName }) => {
  const termsOfServiceContent = `
使用 ${appName}（以下簡稱“本應用”）即表示您同意遵守這些服務條款。如果您不同意這些條款，請不要使用本應用。

1. 服務內容：
   本應用提供露營地資訊的查詢服務，包括經緯度顯示、連結到外部地圖應用（如 Google Maps）及露營場地官網。您同意按照法律規範及本條款使用本應用。

2. 用戶責任：
   您同意僅在合法的情況下使用本應用，並且不得使用本應用進行任何非法、詐騙或有害的活動。

3. 知識產權：
   所有應用中的內容，包括文字、圖像、地圖資料等，部分內容由第三方提供，並屬於相關權利人所有。未經授權，您不得複製、發行或利用本應用中的第三方內容。
   圖片與地圖資料：本應用所使用的圖片及地圖資料來自 [meteoblue]，並受到其版權保護。用戶同意遵守第三方提供者的授權條款，並不得將此類內容用於商業或其他未經授權的用途。

4. 服務中斷與修改：
   我們保留隨時修改、暫停或終止本應用的權利。對於服務的中斷或變更，我們不承擔任何責任。

5. 隱私政策：
   我們尊重您的隱私權，並會遵守適用的隱私法律。請參閱我們的隱私政策以了解詳細內容。

6. 責任限制：
   本應用及其服務提供者對因使用本應用或無法使用本應用所造成的任何直接、間接、偶然或衍生性損害不承擔責任。

7. 終止使用：
   我們可在任何時候終止或暫停您的帳戶或對您使用本應用的權利，無論是因為違反條款或其他原因。

8. 管轄法律：
   這些條款受 [適用法律] 的法律管轄。如果任何條款被發現無效或不可執行，其餘條款仍然有效。

9. 聯繫我們：
   若您有任何問題，請聯繫我們：otislin1102@gmail.com
`;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        minHeight: "100vh",
        width: "100vw",
        overflowY: "auto",
      }}
    >
      <div style={{ textAlign: "center", marginTop: "20px" }}>
        <img src={logo} className="App-logo" alt="logo" />
      </div>
      <div
        style={{
          textAlign: "left",
          padding: "20px",
          whiteSpace: "pre-wrap",
          wordWrap: "break-word",
        }}
      >
        <h1 className="main-font-color">服務條款</h1>
        <div className="main-font-color">{termsOfServiceContent}</div>
      </div>
    </div>
  );
};

export default TermsOfService;
